<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	import { browser } from '$app/environment';
	import { page } from '$app/state';
	import { m } from '$lib/paraglide/messages';

	let {
		class: classValue,
		overrideCurrent,
		breadcrumbs,
	}: {
		class?: ClassValue;
		overrideCurrent?: string;
		retrieveFromState?: boolean;
		breadcrumbs?: Breadcrumb[];
	} = $props();

	$effect(() => {
		if (!breadcrumbs) {
			breadcrumbs = browser
				? history.state['sveltekit:states']?.breadcrumbs
				: page.state.breadcrumbs;
		}
	});

	let segments = $derived.by(() => {
		let breadcrumbsPart = breadcrumbs
			? breadcrumbs.map((part) => ({
					name: part.name.charAt(0).toUpperCase() + part.name.slice(1),
					href: part.slug,
				}))
			: [];

		if (overrideCurrent) {
			breadcrumbsPart = [
				...breadcrumbsPart,
				{
					name: overrideCurrent,
					href: '',
				},
			];
		}

		return breadcrumbsPart;
	});
</script>

<nav aria-label="Breadcrumb" class={['text-sm text-gray-400', classValue]}>
	<ol class="flex flex-wrap items-center space-x-2">
		<li><a href="/" class=" hover:text-gray-700 hover:underline">{m.home()}</a></li>
		{#each segments as segment, index (segment.href)}
			<li class="flex items-center space-x-2">
				<span>/</span>
				{#if index === segments.length - 1}
					<span class="font-bold text-gray-900 hover:no-underline"
						>{overrideCurrent ?? segment.name}</span
					>
				{:else}
					<a href="/{segment.href}" class="hover:text-gray-700 hover:underline">{segment.name}</a>
				{/if}
			</li>
		{/each}
	</ol>
</nav>
